import React from 'react';

const LINKS = [
  { label: 'Work With Me', id: 'work' },
  { label: 'Find Me', id: 'social' },
  { label: 'Links', id: 'links' },
  { label: 'TKB', id: 'tkb' },
];

export const Navbar = ({ onNavigate }) => (
  <header style={{ fontFamily: "'Space Grotesk', sans-serif" }} className="fixed top-0 right-0 z-[70] flex flex-wrap items-center justify-end gap-x-3 gap-y-2 sm:gap-x-5 p-4 sm:p-6 max-w-full">
    <button
      type="button"
      data-testid="nav-home-pill"
      onClick={() => onNavigate('hero')}
      className="bg-primary text-primary-foreground rounded-full px-3 py-1.5 text-[10px] sm:text-xs font-bold tracking-wide hover:bg-cream transition-colors shadow-cream"
    >
      Joe Urbinati
    </button>
    <nav className="flex items-center gap-3 sm:gap-4" aria-label="Primary">
      {LINKS.map((l) => (
        <button
          key={l.id}
          type="button"
          data-testid={`nav-${l.id}`}
          onClick={() => onNavigate(l.id)}
          className="text-[10px] sm:text-xs tracking-wide text-cream/80 hover:text-cream transition-colors"
        >
          {l.label}
        </button>
      ))}
    </nav>
  </header>
);
